import script from "./CraftingAnswers.vue?vue&type=script&setup=true&lang=js"
export * from "./CraftingAnswers.vue?vue&type=script&setup=true&lang=js"

import "./CraftingAnswers.vue?vue&type=style&index=0&id=9041e5c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9041e5c8"]])

export default __exports__